/**
 *   Type of fields.  Maps to the field type names returned from Hubspot
 */
enum HubspotFieldTypes {
    Text = "text",
    PhoneNumber = "phonenumber",
    Select = "select",
    TextArea = "textarea",
    Number = "number",
}

export default HubspotFieldTypes;